import React from 'react';
import footerLogo from '@/assets/footer_logo.svg';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { animateScroll as scroll } from 'react-scroll';
import { footerLinkList } from '@/assets/Const';
import '@/styles/footer.css';

export const Footer = () => {
  const liClass = 'text-sub font-bold';

  const toTop = (
    <span className="footer-to-top">
      <ArrowCircleUpIcon />
      <span className="hidden md:inline-block">TO TOP</span>
    </span>
  );

  return (
    <footer className="bg-contents footer-footer">
      <nav className="my-auto">
        <div className="footer-gray-circle md:bg-background opacity-100">
          <img src={footerLogo} className="logo footer-logo" alt="omise logo" />
          <p className="text-sub text-[10px] md:hidden block grow">
            Copyright © 2024-2025 OMISE CRAFT. All rights reserved.
          </p>
          <div className="cursor-pointer md:hidden block" onClick={scroll.scrollToTop} onKeyDown={scroll.scrollToTop}>
            {toTop}
          </div>
          <ul className="md:flex justify-center items-center footer-gap grow hidden">
            {footerLinkList.map((val) => (
              <li className={liClass + ' footer-text invisible md:visible'} key={val.path}>
                {val.blank ? (
                  <a href={val.path} target="_blank" rel="noreferrer noopener">
                    {val.label}
                  </a>
                ) : (
                  <a href={val.path}>{val.label}</a>
                )}
              </li>
            ))}
          </ul>
          <div
            className="hidden md:block py-4 cursor-pointer md:ml-[90px]"
            onClick={scroll.scrollToTop}
            onKeyDown={scroll.scrollToTop}
          >
            {toTop}
          </div>
        </div>
        <p className="text-sub footer-copy-right hidden md:block ">
          Copyright © 2024-2025 OMISE CRAFT. All rights reserved.
        </p>
      </nav>
    </footer>
  );
};
